(() => {
  const header = document.querySelector('[data-ih-one-header]');
  if (!header) return;
  const launchers = document.querySelectorAll('[data-ih-one-open]');
  launchers.forEach(button => {
    const dialog = document.getElementById(button.dataset.ihOneOpen);
    if (!dialog) return;
    button.addEventListener('click', () => {
      if (dialog.open) return;
      dialog.showModal();
      button.setAttribute('aria-expanded', 'true');
      document.body.classList.add('ih-one-dialog-open');
    });
    dialog.addEventListener('close', () => {
      button.setAttribute('aria-expanded', 'false');
      document.body.classList.remove('ih-one-dialog-open');
      button.focus();
    });
    dialog.querySelectorAll('[data-ih-one-close]').forEach(close => close.addEventListener('click', () => dialog.close()));
    dialog.addEventListener('click', event => {
      if (event.target !== dialog) return;
      const rect = dialog.getBoundingClientRect();
      if (event.clientX < rect.left || event.clientX > rect.right || event.clientY < rect.top || event.clientY > rect.bottom) dialog.close();
    });
  });
  const groups = [...header.querySelectorAll('[data-ih-one-nav]')];
  groups.forEach(group => group.addEventListener('toggle', () => {
    if (group.open) groups.forEach(other => { if (other !== group) other.open = false; });
  }));
  document.addEventListener('click', event => {
    if (!header.contains(event.target)) groups.forEach(group => { group.open = false; });
  });
  document.addEventListener('keydown', event => {
    if (event.key !== 'Escape') return;
    const active = groups.find(group => group.open);
    if (active) { active.open = false; active.querySelector('summary').focus(); }
  });
  const footerGroups = document.querySelectorAll('.ih-one-footer-column');
  const desktop = window.matchMedia('(min-width: 990px)');
  const syncFooter = () => footerGroups.forEach(group => { group.open = desktop.matches; });
  syncFooter();
  desktop.addEventListener('change', syncFooter);
  document.addEventListener('cart-update', event => {
    const cart = event.detail?.cart || event.detail;
    if (typeof cart?.item_count !== 'number') return;
    document.querySelectorAll('[data-ih-one-cart-count]').forEach(node => { node.textContent = String(cart.item_count); });
  });
  window.addEventListener('pageshow', event => {
    if (!event.persisted) return;
    document.body.classList.remove('ih-one-dialog-open');
    document.querySelectorAll('.ih-one-dialog[open]').forEach(dialog => dialog.close());
  });
})();
